import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@material-ui/core';
import { GroupTable } from 'components/Tables/GroupTable/GroupTable';
import { useStyles } from './styles';

const GroupsTable: FC = observer(() => {
  const classes = useStyles();
  return (
    <Container maxWidth='xl' className={classes.container}>
      <GroupTable />
    </Container>
  );
});

export default GroupsTable;
